import apiService from './api.service.js';
import logger from '../utils/logger';

class MetricsService {
  constructor() {
    this.baseURL = process.env.REACT_APP_METRICS_API_URL || 'https://zugspus36d.execute-api.us-west-2.amazonaws.com/dev/dashboard';
  }

  async getDashboardMetrics() {
    try {
      const endpoint = `${this.baseURL}/metrics`;
      const response = await apiService.request(endpoint, {
        method: 'GET'
      });

      if (response.statusCode === 200) {
        return response.body;
      }

      throw new Error('Failed to fetch dashboard metrics');
    } catch (error) {
      logger.error('Error fetching dashboard metrics:', error);
      throw error;
    }
  }
}

export default new MetricsService();
